import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export const ProtectedRoute: React.FC<{ children: React.ReactNode; requirePermissions?: string[] }> = ({
  children,
  requirePermissions,
}) => {
  const { user, loading, hasPermission } = useAuth();

  if (loading) {
    return <div className="flex h-screen items-center justify-center text-slate-400">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requirePermissions && !hasPermission(...requirePermissions)) {
    return (
      <div className="flex h-screen flex-col items-center justify-center gap-2 text-slate-500">
        <p className="text-lg font-semibold">Access restricted</p>
        <p className="text-sm">You don't have permission to view this page.</p>
      </div>
    );
  }
  return <>{children}</>;
};
